import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Button,  Row, Modal, Form } from 'react-bootstrap';
import axios from "axios";
import Visualizza_elenco_presenze_di_un_anno from "./Progetto_x8_elenco_presenze.jsx";
import { useAuth0 } from "@auth0/auth0-react";
 

 
const Menu_generale_alunni = (props) => { 
//    const [somma, calcola_somma] = useState('');
    const [show, setShow] = useState(false);
    const [show_bottone, SET_show_bottone] = useState('');
    const [lista_progetti_anno_scolastico, SET_lista_progetti_anno_scolastico] = useState([]);

    const [anno_scolastico_selezionato, SET_anno_scolastico_selezionato] = useState('');
    const { user, isAuthenticated } = useAuth0();

    function handleClick_visualizza_presenze(event) {
        event.preventDefault();
        //        console.log(input);
        //        const new_alunno = {
        //            ...input,
        //            data_nascita: end_Date
        //        }
        //        console.log(new_alunno);
        //        axios.post('http://localhost:3001/create', newNote)
        console.log('Carica la lista delle presenze ');
//          const dati_per_file_excel = {}        
//        console.log(dati_per_file_excel)
        axios.get('/classi/classi_progetti_entro_un_periodo_alfabetico/' , {
            params: {
                utente: 'utente_unico',
                classe_selezionata: props.classe_selezionata,
                data_selezionata: anno_scolastico_selezionato,
                show_bottone: 'data_la_classe_carica_progetti_attivi'
            }
    }) 
    .then((res) => {
        console.log('-----------------------')

        console.log('CLASSI appena fecciate da mongo')
        console.log(res.data)
        const lista_ridotta = res.data

        /* idroslab */


        SET_lista_progetti_anno_scolastico(res.data)        
      
    //            report_progetti_attivi(res.data)
    }).catch((error) => {
        console.log(error) 
    });
      

    }

    
    function handleClick(event) {
        event.preventDefault();
        //        console.log(input);
        //        const new_alunno = {
        //            ...input,
        //            data_nascita: end_Date
        //        }
        //        console.log(new_alunno);
        //        axios.post('http://localhost:3001/create', newNote)
        console.log('Prepara documenti');
        const dati_per_file_excel = {tutor: props.tutor, classe_selezionata: props.classe_selezionata, 
                                     anno_scolastico_selezionato: anno_scolastico_selezionato,
                                     show_bottone: show_bottone,
                                     lista_alunni: props.lista_alunni,
                                     email: user.email }
//        const dati_per_file_excel = {}        
//        console.log(dati_per_file_excel)
        axios.post('/transfer_s3/preparazione_file_excel', dati_per_file_excel)
        .then((res) => {
            console.log(res.data)

            if ( show_bottone == 'download_file_excel' ) {
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
            }
            if ( show_bottone == 'visualizza_presenze' ) {
                console.log('entrato1')
                console.log(res.data)

                SET_lista_progetti_anno_scolastico(res.data)        
            }

        }).catch((error) => {
            console.log(error)
        });

    }


    const handleClick_presenze = e => {
        e.persist();
        console.log(e.target.value);
        
    };


    const handleChange = e => {
        e.persist();
        console.log(e.target.value);
        SET_anno_scolastico_selezionato(e.target.value)
        
    };

    const Cambia_Stato = (tipo_di_richiesta) => {
        SET_show_bottone(tipo_di_richiesta)
        setShow(true)
//        console.log(ciao);
        
    };


    return (
        <>

        <Modal
            show={show}
            size="lg"
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">

                    </Modal.Title>
            </Modal.Header>
            <Modal.Body>

        <Row>  
        <Form.Label column sm="2">
            Anno scolastico
        </Form.Label>
        
        <Form.Group  className='d-flex justify-content-between' >
        <Form.Check
            value="progetti_attivi"
            type="radio"
            aria-label="radio 2"
            label="In svolgimento"
            onChange={handleChange}
            checked={anno_scolastico_selezionato == "progetti_attivi"}
        />
            <Form.Check
            value="2024"
            type="radio"
            aria-label="radio 1"
            label="2024 / 25"
            onChange={handleChange}
            checked={anno_scolastico_selezionato == "2024"}
        />
            <Form.Check
            value="2023"
            type="radio"
            aria-label="radio 1"
            label="2023 / 24"
            onChange={handleChange}
            checked={anno_scolastico_selezionato == "2023"}
        />
            <Form.Check
            value="2022"
            type="radio"
            aria-label="radio 2"
            label="2022 / 23"
            onChange={handleChange}
            checked={anno_scolastico_selezionato == "2022"}
        />



        {/*anno_scolastico_selezionato */}
            {show_bottone == 'download_file_excel' && <Button onClick={handleClick} disabled={anno_scolastico_selezionato == ''} className="">Excel nuovo </Button>}
            {show_bottone == 'visualizza_presenze' && <Button onClick={handleClick_visualizza_presenze} disabled={anno_scolastico_selezionato == ''} className="">Visualizza presenze </Button>}
        
      
        </Form.Group>
        </Row>
        <Row> 
        <div className='d-flex flex-row-reverse justify-content-between'>

            <h4>     
            {show_bottone == 'visualizza_presenze' && <>Progetti elencati in ordine cronologico  </>}
            </h4>
            </div>
        </Row>
            {show_bottone == 'visualizza_presenze' &&  <Visualizza_elenco_presenze_di_un_anno lista_progetti_anno_scolastico = {lista_progetti_anno_scolastico}/>}               
           
        </Modal.Body>
        </Modal> 

        <div className="d-flex flex-column flex-grow" >
{/*
            <Button onClick={()=> Chiama_lookup('Prove_per_visualizzare')} variant= "outline-primary" className="">Lookup </Button>
        */}
		    <Button onClick={()=> Cambia_Stato('download_file_excel')} variant= "outline-primary" className="">Excel nuovo </Button>
		    <Button onClick={()=> Cambia_Stato('visualizza_presenze')} variant= "outline-primary" className="">Lista presenze </Button>
            </div>     
        </>
    )
}
export default Menu_generale_alunni;